function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.75
}, /*#__PURE__*/React.createElement("path", {
  d: "M341.141 1329.531l-119.643-149.928M221.498 1179.603c26.23501-50.0123 53.42199-100.6597 79.657-150.672M301.155 1028.931c59.53666 18.3167 120.44934 35.9323 179.986 54.249M503.047 1268.629c-7.302-61.8163-14.604-123.6327-21.906-185.449M341.141 1329.531c53.96866-20.3007 107.93734-40.6013 161.906-60.902M503.047 1268.629l124.341 4.137M383.545 1355.043c-14.13467-8.504-28.26933-17.008-42.404-25.512M383.545 1355.043c43.54666-8.7577 87.09334-17.5153 130.64-26.273M627.388 1272.766c-37.73433 18.668-75.46867 37.336-113.203 56.004M481.141 1083.18c39.45333-33.497 78.90667-66.994 118.36-100.491M679.605 1095.529c-26.70135-37.6133-53.40265-75.2267-80.104-112.84M627.388 1272.766c17.25366-58.3407 34.96334-118.8963 52.217-177.237M221.498 1179.603c-4.93667-12.298-9.87333-24.596-14.81-36.894M206.688 1142.709c21.61266-49.6567 43.22534-99.3133 64.838-148.97M271.526 993.739c19.78633-25.702 39.57267-51.404 59.359-77.106M331.169 916.767c-10.00467 37.388-20.00933 74.776-30.014 112.164M330.885 916.633c54.564-9.11367 109.128-18.22733 163.692-27.341M599.501 982.689c-34.97467-31.13233-69.94933-62.26467-104.924-93.397"
}));

var _ref3 = /*#__PURE__*/React.createElement("style", null, "\n        .face { font: bold 120px sans-serif; }\n    ");

var _ref4 = /*#__PURE__*/React.createElement("text", {
  x: 320,
  y: 1220,
  className: "face",
  transform: "rotate(-20 360 1270)"
}, "12");

var SvgD12 = function SvgD12(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "198.249146 880.02063 489.612305 484.870728",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgD12, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/D12.95e846da.svg";
export { ForwardRef as ReactComponent };